import {
    Box,
    Container,
    Spinner,
    Flex,
    Text
} from "@chakra-ui/react";

import PolicyHero from "./PolicyHero";

const PolicyDocument = ({
    document,
    loading,
}) => {
    if (
        loading ||
        !document
    ) {
        return (
            <Flex
            minH="100vh"
            justify="center"
            align="center"
            direction="column"
            gap={4}
            bg="#F8FAFC"
        >
            <Spinner
                size="xl"
                color="#2453FF"
            />

            <Text
                color="gray.500"
                fontSize="sm"
                fontWeight="500"
            >
                Loading document...
            </Text>
        </Flex>
        );
    }

    return (
        <Box
            bg="#F8FAFC"
            minH="100vh"
            py={{
                base: 8,
                md: 16,
            }}
        >
            <Container
                maxW="1000px"
            >
                <PolicyHero
                    document={{
                        ...document,
                        updatedAt:
                            new Date(
                                document.updated_at
                            ).toLocaleDateString(
                                "en-BW",
                                {
                                    day: "numeric",
                                    month: "long",
                                    year: "numeric",
                                }
                            ),
                    }}
                />

                <Box
                    mt={8}
                    bg="white"
                    borderRadius="24px"
                    border="1px solid"
                    borderColor="gray.100"
                    p={{
                        base: 5,
                        md: 8,
                    }}
                    shadow="sm"
                >
                    <Box
                        className="policy-content"
                        color="gray.700"
                        lineHeight="2"
                        dangerouslySetInnerHTML={{
                            __html:
                                document.content,
                        }}
                    />
                </Box>
            </Container>
        </Box>
    );
};

export default PolicyDocument;